import { useLayoutEffect } from "react"

/** The id of index.html's static first paint (NFR-DSH-01, Task 0.6 fix round 1). */
export const BOOT_SCREEN_ID = "boot"

/**
 * index.html paints the sign-in screen as static markup before any script
 * runs, so the largest paint does not wait for the bundle. Every component
 * that can be the app's first visible screen (an auth screen's card, the shell and
 * its loader, the route error) calls this: the static copy is removed in the
 * same commit that puts the real screen in place, before the browser paints,
 * so there is never a blank frame, never both copies, and nothing read twice
 * by a screen reader.
 */
export function useReplaceBootScreen(): void {
  useLayoutEffect(removeBootScreen, [])
}

/** Removes the static first paint now (a no-op once it is gone). */
export function removeBootScreen(): void {
  document.getElementById(BOOT_SCREEN_ID)?.remove()
}
